// extracted by css-extract-rspack-plugin
module.exports =  {"custom_switch":"Notifications_custom_switch__zhQTv","custom_tabs":"Notifications_custom_tabs__Kdo7r","custom_tabs_small":"Notifications_custom_tabs_small__42lqR"};